// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.import-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 10px;
}

.import-table th,
.import-table td {
    padding: 12px;
    text-align: left;
    word-wrap: break-word;
    max-width: 120px;
}

.import-table tr,
.import-table td {
    padding: 12px;
}

.import-table th {
    background-color: #f4f4f4;
    border: none;
    max-width: 1000px;

}

.import-table tr td {
    border: none;
    color: rgba(59, 69, 79, 1);
    font-weight: 700;

}

.import-table tr {
    background-color: #fff;
    overflow: hidden;
    font-weight: 800;
    font-size: 16px;
    border-radius: 12px !important;
}

.import-table-row {
    box-shadow: 0px 2px 5px 2px #B9B9B9 !important;
}

.import-table tr td:first-child {
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
}

.import-table tr td:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
@media screen and (max-width: 1080px) {
    /* Adjust the breakpoint as needed */
    .import-table-container {
        overflow-x: scroll;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Import/Common/ImportList.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;;AAEpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,oCAAoC;IACpC;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* styles.css */\n.import-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 10px;\n}\n\n.import-table th,\n.import-table td {\n    padding: 12px;\n    text-align: left;\n    word-wrap: break-word;\n    max-width: 120px;\n}\n\n.import-table tr,\n.import-table td {\n    padding: 12px;\n}\n\n.import-table th {\n    background-color: #f4f4f4;\n    border: none;\n    max-width: 1000px;\n\n}\n\n.import-table tr td {\n    border: none;\n    color: rgba(59, 69, 79, 1);\n    font-weight: 700;\n\n}\n\n.import-table tr {\n    background-color: #fff;\n    overflow: hidden;\n    font-weight: 800;\n    font-size: 16px;\n    border-radius: 12px !important;\n}\n\n.import-table-row {\n    box-shadow: 0px 2px 5px 2px #B9B9B9 !important;\n}\n\n.import-table tr td:first-child {\n    border-top-left-radius: 10px !important;\n    border-bottom-left-radius: 10px !important;\n}\n\n.import-table tr td:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n@media screen and (max-width: 1080px) {\n    /* Adjust the breakpoint as needed */\n    .import-table-container {\n        overflow-x: scroll;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
